var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmarkPartial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2442 8.82486L9.70835 12.3599C9.55208 12.5161 9.34016 12.6038 9.11919 12.6038C8.89822 12.6038 8.68629 12.5161 8.53002 12.3599L6.76252 10.5924C6.61072 10.4352 6.52673 10.2247 6.52863 10.0062C6.53053 9.78769 6.61817 9.57868 6.77267 9.42417C6.92718 9.26967 7.13619 9.18203 7.35469 9.18013C7.57318 9.17823 7.78369 9.26222 7.94085 9.41402L9.11919 10.5924L12.0659 7.64652C12.223 7.49473 12.4335 7.41073 12.652 7.41263C12.8705 7.41453 13.0795 7.50217 13.234 7.65668C13.3885 7.81118 13.4762 8.02019 13.4781 8.23869C13.48 8.45719 13.396 8.66769 13.2442 8.82486Z",
    fill: "#393A3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkPartial);
export default __webpack_public_path__ + "static/media/checkmark-partial.0f4fe339889d70148dc1ba7efc8cba61.svg";
export { ForwardRef as ReactComponent };